import ekozAxios from './instance/axios';

export const trackEvent = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/analytics/track_event',
  data,
  ignoreToken: true,
});

export const trackSession = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/analytics/track_session',
  data,
  ignoreToken: true,
});

export const saveRecording = (data) => ekozAxios.request({
  method: 'post',
  url: '/admin/analytics/save_recording',
  data,
  ignoreToken: true,
});
